<template>
  <div>
    <PermissionValidation
      :marketId="marketId"
      rule="enableApproveAreaInterest"
    >
      <approve-list :loading="isMainLoading" @onInit="getApproveTasksByMarket"></approve-list>
    </PermissionValidation>
  </div>
</template>

<script>
import ApproveList from "../../components/ApproveList.vue";
import PermissionValidation from "../../components/PermissionValidation.component.vue";
export default {
  components: {
    ApproveList,
    PermissionValidation
  },
  props: {
    isMainLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId
    };
  },
  methods: {
    getApproveTasksByMarket() {
      this.$emit("onGetApproveTasksByMarket");
    }
  }
};
</script>

<style>
</style>